import { createUser } from '../../../entities/auth/user/actions';
import { ThunkAction } from '../../../store/middleware';

export interface IRegistrationDetails {
	name: string;
	email: string;
	phone: string;
	company: string;
	password: string;
	accepted: boolean;
	recaptchaToken?: string;
}

export const ActionTypes = {
	SET_DETAILS: 'REGISTER_SET_DETAILS' as 'REGISTER_SET_DETAILS',

	ADMIN_REGISTRATION_REQUEST: 'REGISTER_ADMIN_REGISTRATION_REQUEST' as 'REGISTER_ADMIN_REGISTRATION_REQUEST',
	ADMIN_REGISTRATION_RECEIVE: 'REGISTER_ADMIN_REGISTRATION_RECEIVE' as 'REGISTER_ADMIN_REGISTRATION_RECEIVE',
	ADMIN_REGISTRATION_FAILURE: 'REGISTER_ADMIN_REGISTRATION_FAILURE' as 'REGISTER_ADMIN_REGISTRATION_FAILURE'
};

export const requestAdminRegistration = () => ({ type: ActionTypes.ADMIN_REGISTRATION_REQUEST });
export const receiveAdminRegistration = () => ({ type: ActionTypes.ADMIN_REGISTRATION_RECEIVE });
export const failureAdminRegistration = (error: Error) => ({ type: ActionTypes.ADMIN_REGISTRATION_FAILURE, payload: { error } });

export const setRegistrationDetails = (details: Partial<IRegistrationDetails>) => ({ type: ActionTypes.SET_DETAILS, payload: details });

export const registerAdminUser = (
	email: string,
	password: string,
	recaptchaToken: string
): ThunkAction<any> => async (dispatch, getState, { _deprecatedApi: api }) => {
	dispatch(requestAdminRegistration());
	try {
		await dispatch(createUser(email, password, '', recaptchaToken));
		dispatch(receiveAdminRegistration());
		dispatch(setRegistrationDetails({}));
	} catch (e) {
		dispatch(failureAdminRegistration(e));
		throw e;
	}
};

export type Actions = ReturnType<typeof setRegistrationDetails> |
	ReturnType<typeof requestAdminRegistration> |
	ReturnType<typeof receiveAdminRegistration> |
	ReturnType<typeof failureAdminRegistration>;
